import { AVALANCHE_SERVICES } from "@/lib/conditions/ski-touring-scoring-v4";

type Props = {
  dangerLevel: number | null;
  proxyLevel?: "green" | "amber" | "red";
  proxyLabel?: string;
  country: string;
};

const COLOURS: Record<number, { bg: string; text: string; label: string }> = {
  1: { bg: "bg-emerald-100", text: "text-emerald-700", label: "Low" },
  2: { bg: "bg-emerald-100", text: "text-emerald-700", label: "Moderate" },
  3: { bg: "bg-amber-100", text: "text-amber-700", label: "Considerable" },
  4: { bg: "bg-red-100", text: "text-red-700", label: "High" },
  5: { bg: "bg-red-200", text: "text-red-800", label: "Very High" },
};

export default function AvalancheBadge({ dangerLevel, proxyLevel, proxyLabel, country }: Props) {
  const service = AVALANCHE_SERVICES[country];
  const hasEaws = dangerLevel !== null && dangerLevel >= 1 && dangerLevel <= 5;

  const inner = hasEaws ? (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 ${COLOURS[dangerLevel!].bg} ${COLOURS[dangerLevel!].text}`}>
      <span className="text-[12px] font-bold">{dangerLevel}</span>
      <span className="text-[11px] font-semibold">{COLOURS[dangerLevel!].label}</span>
    </span>
  ) : proxyLevel ? (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 ${
      proxyLevel === "red" ? "bg-red-100 text-red-700" : proxyLevel === "amber" ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700"
    }`}>
      <span className="text-[11px] font-semibold">Weather proxy, not an avalanche forecast</span>
    </span>
  ) : (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-stone-100 px-2.5 py-1 text-stone-700">
      <span className="text-[11px] font-semibold">No bulletin data</span>
    </span>
  );

  return (
    <div className="flex items-center gap-2 mb-3">
      <span className="text-[10px] font-semibold uppercase tracking-[0.8px] text-text-muted">Avalanche</span>
      {service ? (
        <a href={service.url} target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity">
          {inner}
        </a>
      ) : inner}
      {!hasEaws && (
        <span className="text-[9px] text-text-muted italic">
          {proxyLabel ? `${proxyLabel}. ` : ""}Check the official bulletin
        </span>
      )}
    </div>
  );
}
